import { Component } from '@opten/compiler/metadata/component';
import { isPad } from '../utilities/detection';
import { hasClass } from '@opten/dom/has-class';
import { addClass } from '@opten/dom/add-class';

declare var ScrollMagic: any;
declare var TweenMax: any;
declare var Linear: any;
const scrollMagicController = new ScrollMagic.Controller();

@Component({ className: 'js-magic-scroll', observe: true })
export class MagicScrollComponent {
	constructor(private triggerElement: HTMLElement) {
		const scene = this.triggerElement.getAttribute('data-magic-scene');
		if (scene != null) {
			switch (scene.toUpperCase()) {
				case 'KEYVISUAL':
					this.initSceneKeyvisual();
					break;
				case 'STICKY':
					this.initSceneSticky();
					break;
				case 'CLASSTOGGLE':
					this.initSceneClassToggle();
					break;
				default:
					break;
			}
		}
	}
	

	private initSceneKeyvisual() {
		const targetElements = Array.from(
			this.triggerElement.querySelectorAll<HTMLElement>(
				'.js-magic-scroll-target'
			)
		);


		//spacingTop = 0;
		targetElements.forEach(target => {
			let scene = this.setSceneKeyvisual(target);
			window.addEventListener('resize', () => {
				scene.destroy(true);
				scene = this.setSceneKeyvisual(target);
			});
		});
	}
	private setSceneKeyvisual(target: HTMLElement) {
		let offset = getSceneKeyvisualOffset();
		let cssTransformation = {};
		let indicatorsName = "keyvisual tween";
		if (hasClass(target, 'c-keyvisual__image__dots-picture')) {
			indicatorsName += " dots-picture"
			cssTransformation = { marginTop: getSceneKeyVisualSpacingTop() + "px" };
			if (window.innerWidth >= 1370) {
				cssTransformation = { marginTop: getSceneKeyVisualSpacingTop() + "px", transform: "translate3d(70%,30%,0)" }
			}
			else if (window.innerWidth >= 1200) {
				cssTransformation = { marginTop: getSceneKeyVisualSpacingTop() + "px", transform: "translate3d(70%,30%,0) scale(0.8)" }
			}
			else if (window.innerWidth >= 1024) {
				cssTransformation = { marginTop: getSceneKeyVisualSpacingTop() + "px", transform: "translate3d(70%,10%,0) scale(0.7)" }
			}
		}
		else {
			cssTransformation = { width: "100%", marginTop: getSceneKeyVisualSpacingTop() + "px" };//, transform: "translate3d(0," + getSceneKeyVisualSpacingTop() + "px,0)" }
		}
		const classToToggle = 'is--sticky';
		return new ScrollMagic.Scene({
			triggerElement: this.triggerElement,
			duration: '100%',
			offset: offset
		})
			.setClassToggle(this.triggerElement, classToToggle)

			.setTween(
				TweenMax.to(target, 0.3, {
					css: cssTransformation,
					ease: Linear.easeNone
				})
			)
			//.addIndicators({ name: indicatorsName })
			.addTo(scrollMagicController);
	}

	private initSceneClassToggle() {
		const classToToggle =
			this.triggerElement.getAttribute('data-magic-class-toggle') ||
			'is-animating';
		const triggerHook =
			this.triggerElement.getAttribute('data-magic-trigger-hook') ||
			'0.9';
		const offset =
			this.triggerElement.getAttribute('data-magic-offset') || '0';

		const scene = new ScrollMagic.Scene({
			triggerElement: this.triggerElement,
			triggerHook: parseFloat(triggerHook),
			offset
		})
			.setClassToggle(this.triggerElement, classToToggle)
			.reverse(false)
			.addTo(scrollMagicController);

	}

	private initSceneSticky() {
		const classToStickyIn ='is--sticky';
		const classStickyOut = 'is--sticky--out'
		const windowWidth = window.innerWidth;
		let offset = 40;
		let offsetOut = this.triggerElement.getBoundingClientRect().height;
		let triggerHook = 0;

		if(windowWidth >= 1370){
			offset = 90;
			offsetOut -= 120;
		}
		else if(windowWidth >= 1024){
			offset = 70;
			offsetOut -= 100;
		}
		else{
			offsetOut -= 70;
		}
		if(windowWidth < 1200){
			triggerHook = 75 / window.innerHeight;
		}

		//const id = this.triggerElement.hasAttribute('id') ? " with id: " + this.triggerElement.getAttribute('id') : '';

		const sceneOne = new ScrollMagic.Scene({
			triggerElement: this.triggerElement,
			triggerHook: triggerHook,
			offset: offset
		})
			.setClassToggle(this.triggerElement, classToStickyIn)
			.addTo(scrollMagicController)
			//.addIndicators({ name: 'sticky scene' + id });

		const sceneTwo = new ScrollMagic.Scene({
			triggerElement: this.triggerElement,
			triggerHook: triggerHook,
			offset: offsetOut
		})
			.setClassToggle(this.triggerElement, classStickyOut)
			.addTo(scrollMagicController)
			//.addIndicators({ name: 'sticky scene out' + id });	
	}


}

export function getSceneKeyvisualOffset(): number {
	let offset = (window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight) / 100 * 40;
	if (isPad()) {
		offset -= 75;
	}
	else if (isPad() == false) {
		offset -= 95;
	}
	return offset;
}

export function getSceneKeyVisualSpacingTop(): number {
	let spacingTop = 0;//120;
	const windowWidth = window.innerWidth;

	// if (windowWidth >= 1200 && windowWidth < 1370) {
	// 	spacingTop = 110;
	// }
	// else 
	if (windowWidth >= 1024 && windowWidth < 1370) {
		spacingTop -=30;
	}
	else if(windowWidth >= 1370){
		spacingTop -= 10;
	}
	// else{
	// 	spacingTop += 95;
	// }
	spacingTop += (window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight);
	return spacingTop;
}
